import React, { useState } from "react";
import { Box, Button, Typography, Stack, Link, TextField } from "@mui/material";
import { IMeeting } from "../../../../types/database/Meeting";

interface MeetingDetailsModalProps {
    meeting: IMeeting | null;
    onSaved?: () => void; // callback to refresh meetings
}

export const MeetingDetailsTab: React.FC<MeetingDetailsModalProps> = ({ meeting, onSaved }) => {

    if (!meeting) return null;

    return (
        <Box p={2}>
                <Stack spacing={2}>
                    <Typography variant="subtitle1"><b>Date:</b> {meeting.event_start ? new Date(meeting.event_start).toLocaleString() : "N/A"}</Typography>
                    <Typography variant="subtitle1"><b>Advisor:</b> {meeting.advisor?.name}</Typography>
                    <Typography variant="subtitle1"><b>Company:</b> {meeting.project?.name}</Typography>
                    <Typography variant="subtitle1"><b>Status:</b> {meeting.status}</Typography>
                    {meeting.fireflies_url && (
                        <Typography variant="subtitle1">
                            <b>Fireflies Summary:</b> <Link href={meeting.fireflies_url} target="_blank" rel="noopener">View on Fireflies</Link>
                        </Typography>
                    )}
                    {meeting.meetgeek_id && (
                        <Typography variant="subtitle1">
                            <b>Meetgeek:</b> <Link href={`https://app.meetgeek.ai/meeting/${meeting.meetgeek_id}`} target="_blank" rel="noopener">View on Meetgeek</Link>
                        </Typography>
                    )}
                    {meeting.short_summary && (
                        <>
                            <Typography variant="subtitle1"><b>Summary:</b></Typography>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>{meeting.short_summary}</Typography>
                        </>
                    )}
                    {meeting.video_url && (
                        <>
                            <Typography variant="subtitle1"><b>Video:</b></Typography>
                            <video src={meeting.video_url} controls style={{ width: '100%', maxHeight: 400 }} />
                        </>
                    )}

                </Stack>


        </Box >
    );
}; 